/**
 * A Reusable Search component, consisting of an input where text is entered,
 * and updates the url search params to fetch search results.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import { InputAdornment } from '@mui/material';
import TextInput from './TextInput/TextInput';
import locationProps from '../../Lib/Utils/PropTypes/location-props';
import { ReactComponent as SearchSVG } from '../../Assets/icons/search.svg';

class Search extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const currentParams = location.search;
    const inputValue = queryString.parse(currentParams.slice(1)).search || '';

    this.state = {
      search: inputValue,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  /**
   * Updates local state with the input values to control the inputs. Calls the
   * updateUrl from props
   *
   *  @param {object} target {
   *    @property {string} name the input name,
   *     @property {string} value the input value
   *   }
   */
  handleChange({ target: { name, value } }) {
    const { updateUrl } = this.props;
    this.setState(
      {
        [name]: value,
      },
      updateUrl.bind(null, name, value),
    );
  }

  render() {
    const { search } = this.state;

    return (
      <TextInput
        id="search-field"
        label="Search"
        name="search"
        value={search}
        onChange={this.handleChange}
        variant="standard"
        endAdornment={
          <InputAdornment position="end">
            <SearchSVG />
          </InputAdornment>
        }
      />
    );
  }
}

Search.propTypes = {
  location: locationProps.isRequired,
  updateUrl: PropTypes.func.isRequired,
};

export default Search;
